<template>
    <main class="pd-main pb-100">
      <div class="main-content">
        <circle-spin class="m-0" v-if="firstLoad"></circle-spin>
        <div class="row" v-else>
          <div class="col-12">
            <div class="card" v-if="!open_test">
                 <h4 class="card-title text-uppercase header-bar">
                    <strong>Test on {{training_title}}</strong>
                </h4>
                <div class="card-body p-50 text-center">
                    <div class="pb-10">
                        <i class="fs-svg ion-ios-paper-outline"></i>
                    </div>
                    <div class="mb-10" v-if="training_title == 'Active Listening'">
                       <h5> Welcome! </h5>
                       In this session you are going to be asked some multiple choice questions based on
                        your {{training_title}} Training.<br>

                        To proceed on your journey as a Listener on Fitila, you have to score a minimum of 
                        <strong>15/20</strong>
                    </div>
                    <div class="mb-10" v-else>
                       <h5> Welcome! </h5>
                       In this session you are going to be asked some multiple choice questions based on
                        your {{training_title}} Training.<br>

                        You have to score a minimum of <strong>15/20</strong> to get a certificate for the training.
                    </div>
                    <a class="btn btn-sm btn-round btn-primary" href="#" @click="startTest">Take test</a>
                </div>
            </div>
            <div class="card" v-else>
                 <h4 class="card-title text-uppercase header-bar">
                    <strong>{{training_title}} Test</strong>
                    <div>
                       <router-link 
                        tag="button" 
                        :to="'/listener/training/'+training_id" 
                        class=" btn btn-bold btn-xs btn-secondary text-right mr-10">
                            Back
                        </router-link>
                        <button v-if="loadingResult" disabled class="btn btn-bold btn-xs btn-primary"> 
                            <circle-spin></circle-spin>
                        </button>
                        <button v-else
                        :disabled="answersArray.length != test_content.length"
                        @click="submitAnswers" 
                        class="modal-trigger btn btn-bold btn-xs btn-primary text-right">
                            Submit
                        </button>
                        
                    </div>
                        
                </h4>
                <div class="card-body p-0 m-30 row no-margin b-1">
                    <div class="col-md-6 p-10 br-1 br-primary">
                        <div class="pb-10" v-for="(content,i) in odd_content" :key="i">
                                    <div>
                                        <h6>{{i + 1}}. {{content.question}}</h6>
                                        <div v-for="(option,j) in all_answers[i]" :key="j">
                                            <div>
                                                    <input type="radio" 
                                                    @change="selectedAnswer" 
                                                    :value="{id: i, answer: option.option, correct:option.correct}" 
                                                    :key='`question${i}`' 
                                                    :name='`question${i}`'>
                                                    <span class="pl-10" :for="option.option">{{option.option}}</span>
                                            </div>
                                        </div>   
                                    </div>
                                    
                        </div>
                    </div>
                    <div class="col-md-6 p-10">
                        <div class="pb-10" v-for="(content,i) in even_content" :key="i">
                            <div>
                                <h6>{{i +1 +Math.round(test_content.length/2)}}. {{content.question}}</h6>
                                <div v-for="(option,j) in all_answers[i+Math.round(test_content.length/2)]" :key="j">
                                    <div>
                                        <input type="radio" 
                                        @change="selectedAnswer" 
                                        :value="{
                                            id: i+Math.round(test_content.length/2), 
                                            answer: option.option, 
                                            correct:option.correct
                                        }"
                                        :key='`question${i+Math.round(test_content.length/2)}`' 
                                        :name='`question${i+Math.round(test_content.length/2)}`'>
                                        <span class="pl-10" :for="option.option">{{option.option}}</span>
                                    </div>
                                </div>    
                            </div>
                                    
                        </div>
                    </div>
                </div>
                <modal name="result" class="modal-container" height="auto" :clickToClose="false">
                    <div class="modal-content">
                    <div class="boxed boxed--lg boxed--border">
                        <header class="no-border">
                        <div class="header-bar flexbox pl-20 justify-content-between">
                            <h4>Test Result</h4>
                        </div>
                        </header>
                        <div v-if="score >= 15" class="p-20">
                            <h5>Congratulations!</h5>
                            <p>You just completed the {{training_title}} Training Course and had a 
                                total score of <strong>{{score}}/20</strong>. You can now proceed.
                            </p>
                            <router-link 
                            to="/listener/chat" tag="a"
                             class="btn btn-sm btn-round btn-primary">Proceed
                            </router-link>
                        </div>
                        <div v-else-if="score < 15 && training_title == 'Active Listening'" class="p-20">
                            <h5>Good shot!</h5>
                            <p>You just took the {{training_title}} Training Course and had a 
                                total score of <strong>{{score}}/20</strong>. You will have to retake and pass the test 
                                before you can proceed.
                            </p>
                            <button @click="Reload" class="btn btn-sm btn-round btn-primary">Retake</button>
                        </div>
                        <div v-else class="p-20">
                            <h5>Good shot!</h5>
                            <p>You just took the {{training_title}} Training Course and had a 
                                total score of <strong>{{score}}/20</strong>. You will have to retake and pass the test 
                                to get a certificate on it.
                            </p>
                            <button @click="Reload" class="btn btn-sm btn-round btn-primary">Retake</button>
                        </div>
                        
                    </div>
                    </div>
                </modal>
            </div>
          </div>
        </div>
    </div>
    </main>
</template>

<script>
import axios from 'axios'
import allMixins from '../../mixins.js'

export default {
    name:"trainingTest",
    mixins: [allMixins],
    data() {
        return {
            firstLoad: false,
            loadingResult: false,
            loading: false,
            id_title: [],
            training_title: '',
            training_id: null,
            open_test: false,
            test_content: [],
            all_answers: [],
            odd_content: {},
            even_content: {},
            answer: null,
            answersArray: [],
            score: 0
        }
    },
    methods: {
        Reload() {
            window.location.reload()
        },
        startTest() {
            this.open_test = true
        },
        isEmpty(obj) {
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) return false
            }
            return true
        },
        hideModal(a) {
            a.hide('result')
        },
        selectedAnswer($event) {
            this.answer = $event.target._value
            let is_duplicate = this.answersArray.filter( el => {return el.id == this.answer.id})
           if( is_duplicate.length < 1){
                this.answersArray.push(this.answer)
                // console.log(this.answersArray)
            }
            else {
                this.answersArray[this.answer.id] = this.answer
                // console.log(this.answersArray)
            }
        },
        submitAnswers() {
            this.loadingResult = true
            // console.log(this.answersArray)
            for(let i=0; i<this.answersArray.length; i++) {
                if(this.answersArray[i].correct == true){
                    this.score ++  
                }
            }
            if(this.score < 15){
                this.loadingResult = false
              this.$modal.show("result");
            }
            else {
            	let details = this.$jwt.decode(this.retrieveToken(window.btoa('userToken')), "inGXVHWPU9BB5q2oix1r-zaA")
                axios.get(`users/find/${details.id}`)
                .then(res => { 
                    let userData = {
                        listenerId: res.data.listener[0].id,
                        trainingId: this.training_id,
                        score: this.score
                    }
                    axios.post('/admin/training/complete/', userData)
                    .then(res => {
                        // console.log(res)
                        this.loadingResult = false
                        this.$modal.show("result");
                    })
                    .catch(err => {
                        this.loadingResult = false
                        this.$notify({
                                group: 'response',
                                type: 'error',
                                title:  `${err.response.data.message}`,
                                duration: 5000,
                                ignoreDuplicates: true
                            });    
                    })
                })
                .catch(err => {
                    this.loadingResult = false
                  this.$notify({
                                group: 'response',
                                type: 'error',
                                title:  `${err.response.data.message}`,
                                duration: 5000,
                                ignoreDuplicates: true
                            });   
                })
                
            }
        }      
    },
    mounted() {
        this.firstLoad = true
         this.id_title = this.$route.params.payload.split('&')
         this.training_title = this.id_title[0]
         this.training_id = this.id_title[1]
          axios.get(`/admin/get?type=training&id=${this.training_id}`)
         .then(res => {
             this.firstLoad = false
            this.test_content = res.data.content.tests[0].answers
            for(let i=0; i<this.test_content.length; i++) {
                // put the answers together and then shuffle before pushing new array
                // each.
                let arr = []
                arr.push(
                    {option:this.test_content[i].invalid_answers[0], correct: false},
                    {option:this.test_content[i].invalid_answers[1], correct: false},
                    {option:this.test_content[i].correct_answer, correct: true}
                )
                this.shuffle(arr)
                this.all_answers.push(arr)
            }
            // console.log(this.all_answers)
            this.odd_content = this.test_content.filter((content,i) => {
                return i < ( this.test_content.length/2)
            })
            this.even_content = this.test_content.filter((content, i) => {
                return i >= ( Math.round( this.test_content.length/2)) && i < this.test_content.length
            })
         })
        .catch(err => {
            this.firstLoad = true
            this.$notify({
                        group: 'response',
                        type: 'error',
                        title:  `${err.response.data.message}`,
                        duration: 5000,
                        ignoreDuplicates: true
            })
        })
    }
}
</script>